import React, { useEffect, useState } from 'react';
import { Text, Input, VStack, Pressable, HStack, Modal, Center, useTheme } from 'native-base';
import { useDebounce } from 'use-debounce';
import ResultItem from './ResultItem';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { searchAPI } from '../../context/search';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { useCategoriesState } from '../../context/categories';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { isArrayValid, combinePostsAndTopics } from '../utils/helpers';
import { SEARCH_RESULTS_MAX, SEARCH_TERM_MIN, MODAL_WIDTH, PREVIEW_LENGTH, DEBOUNCE_DELAY } from '../Constants';
import { LANGUAGES } from '../Constants';
const SearchForumModal = _ref => {
  let {
    navigation,
    showSearchModal,
    setShowSearchModal
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const authState = useAuthState();
  const envState = useEnvState();
  const [term, setTerm] = useState('');
  const pageForPreview = 1;
  const [errorMessage, setErrorMessage] = useState('');
  const [searchForumResult, setSearchForumResult] = useState([]);
  const [searchResultLength, setSearchResultLength] = useState(0);
  const [debouncedValue] = useDebounce(term, DEBOUNCE_DELAY);
  const isInputValid = debouncedValue.length >= SEARCH_TERM_MIN;
  const categoriesState = useCategoriesState();
  const {
    forumCategories: categories,
    rootProductCategory
  } = categoriesState;
  const [selectedCategory, setSelectedCategory] = useState('');
  useEffect(() => {
    if (isInputValid) {
      doSearch();
    } else {
      handleErrorMessage();
    }
  }, [debouncedValue, selectedCategory]);
  const doSearch = async () => {
    setSearchForumResult([]);
    try {
      const response = await searchAPI.searchForum(envState.base_url, debouncedValue, pageForPreview, rootProductCategory.name, authState.api_key);
      if (response && isArrayValid(response.posts)) {
        const {
          posts,
          topics
        } = response;
        setSearchResultLength(posts.length);

        // if more than 3 results, limit to 3
        if (posts !== null && posts !== void 0 && posts.length && (posts === null || posts === void 0 ? void 0 : posts.length) > PREVIEW_LENGTH) {
          posts.length = PREVIEW_LENGTH;
          topics.length = PREVIEW_LENGTH;
        }
        const updatedPosts = combinePostsAndTopics(posts, topics);
        setSearchForumResult(updatedPosts);
        return updatedPosts;
      }
    } catch (err) {
      console.log('Error while searching forum');
      return [];
    }
  };
  const handleErrorMessage = () => {
    if (term.length === 0 && !isInputValid) {
      setErrorMessage('');
    } else if (!isInputValid) {
      setErrorMessage(`Please enter at least ${SEARCH_TERM_MIN} characters`);
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showSearchModal,
    onClose: () => setShowSearchModal(false),
    size: MODAL_WIDTH,
    w: "container",
    _overlay: {
      style: {
        position: 'fixed'
      }
    }
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Header, {
    justifyContent: "center",
    alignItems: "center"
  }, "Search Forum"), /*#__PURE__*/React.createElement(Modal.Body, null, isArrayValid(searchForumResult) ? /*#__PURE__*/React.createElement(Text, null, searchResultLength >= SEARCH_RESULTS_MAX ? SEARCH_RESULTS_MAX + '+' : searchResultLength, ' ', searchResultLength === 1 ? 'Post' : 'Posts', selectedCategory && ' in #' + selectedCategory) : debouncedValue && debouncedValue.length >= SEARCH_TERM_MIN ? /*#__PURE__*/React.createElement(Text, {
    my: "2"
  }, "No posts found") : null, /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMagnifyingGlass
  }), /*#__PURE__*/React.createElement(Input, {
    placeholder: LANGUAGES.PLACEHOLDERS.SEARCH_FORUM,
    value: term,
    onChangeText: text => setTerm(text),
    borderWidth: 0,
    autoFocus: true,
    w: "93%",
    marginLeft: 3
  })), isArrayValid(searchForumResult) ? /*#__PURE__*/React.createElement(React.Fragment, null, searchForumResult.map(item => /*#__PURE__*/React.createElement(ResultItem, {
    key: item.blurb,
    navigation: navigation,
    item: item,
    term: term,
    setShowSearchModal: setShowSearchModal
  }))) : /*#__PURE__*/React.createElement(Center, {
    py: "2"
  })), errorMessage && /*#__PURE__*/React.createElement(Text, {
    color: colors.searchModal.input.invalid,
    fontSize: "xs"
  }, errorMessage)), /*#__PURE__*/React.createElement(Modal.Footer, {
    justifyContent: "center",
    alignItems: "center"
  }, term && term.length >= SEARCH_TERM_MIN && isArrayValid(searchForumResult) && searchResultLength > PREVIEW_LENGTH ? /*#__PURE__*/React.createElement(Pressable, {
    w: "100%",
    px: "20",
    py: "2",
    borderWidth: 1,
    borderColor: colors.searchModal.viewAll.border,
    borderRadius: 10,
    bg: "transparent",
    onPress: () => {
      setShowSearchModal(false);
      navigation.navigate('SearchForum', {
        term
      });
    },
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.searchModal.viewAll.text,
    fontWeight: "bold"
  }, "View All")) : '')));
};
export default SearchForumModal;
//# sourceMappingURL=SearchForumModal.js.map